import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { bindSystemThemeListener } from '@/shared/stores';
import { isNative, setAppReady } from '@/shared/bridge';
import { bindNativeThemeSync } from '@/app/runtime/theme-sync';

/**
 * 모든 라우트의 공통 셸. chrome 없음 — 자식 layout 이 시각 책임.
 *
 * 전역 effect:
 *   - `bindSystemThemeListener` — 시스템 dark/light 추종 (cleanup 자동)
 *   - `bindNativeThemeSync`     — 적용 테마를 native 셸(상태바·시스템 배경)에 통지 (native only)
 *   - `setAppReady`             — WebView splash fade-out 트리거 (native only, idempotent)
 */
export function RootLayout() {
  useEffect(() => bindSystemThemeListener(), []);
  useEffect(() => bindNativeThemeSync(), []);
  useEffect(() => {
    if (isNative()) setAppReady();
  }, []);
  return <Outlet />;
}
